export const initStickyHeader = () => {
    let header = document.getElementById('header');
    const checkScroll = () => {
        let shouldAddClass = header.classList.contains('fixed') && window.scrollY > 25;
        header.classList.toggle('scrolled', shouldAddClass);
    };

    window.addEventListener('scroll', checkScroll);
    checkScroll();
};
